import { Input } from "component/form/input"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { deliveryInfoState } from "state"

export default function ReceiveName() {
  const deliveryInfo = useRecoilValue(deliveryInfoState)
  const setDeliveryInfo = useSetRecoilState(deliveryInfoState)

  const handleBlur = (e) => {
    const { value } = e.target
    setDeliveryInfo({
      ...deliveryInfo,
      receiverName: {
        ...deliveryInfo.receiverName,
        validate: value ? "" : "Tên người nhận không được để trống.",
      },
    })
  }

  const handleChange = ({ target }) => {
    setDeliveryInfo({
      ...deliveryInfo,
      receiverName: {
        ...deliveryInfo.receiverName,
        value: target.value,
      },
    })
  }

  return (
    <>
      <Input
        className="deliveryInfomation__input"
        placeholder={"Nhập tên người nhận"}
        value={deliveryInfo.receiverName.value}
        onBlur={handleBlur}
        onChange={handleChange}
        validateText={deliveryInfo.receiverName.validate}
        validateType={'danger'}
        validateClass={'hidden'}
      />
      <span className="text-[#FF424E] text-sm font-normal">
        {deliveryInfo.receiverName.validate}
      </span>
    </>
  )
}
